export const VERIFY_DETAIL_ZHCHT = {
    vertifyTypeAll: 'å¨é¨',
    vertifyTypeError: 'é¯å¡«',
    vertifyTypeEmpty: 'æ¼å¡«'
};
